<db-dialog-wrapper [dialog]="this" [width]="'500px'" [height]="'255px'" [canClose]="!loading" [fullScreen]="isMobile">
  <div class="db-change-php-engine">
    <div class="db-change-php-engine-dialog__header">{{'text_changePhpEngine' | dbText}}</div>
    <div class="db-change-php-engine-dialog__message mt15">
      <p>Do you really want to change the version of the PHP<br/>
        to <b>PHP {{phpVersion}}</b>. The change takes a couple of minutes.<br/>
        Your site visitors will not experience downtime.</p>
    </div>
    <div class="db-change-php-engine-dialog__buttons mt30">
      <a class="ds-btn" (click)="cancel()" [ngClass]="{'ds-btn-disabled': !!loading}"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': !!loading}" (click)="changePHPversion()">
        <span *ngIf="!loading" >Change to PHP {{phpVersion}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
